import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';
import { map } from 'rxjs/operators';
var EnvironmentService = /** @class */ (function (_super) {
    tslib_1.__extends(EnvironmentService, _super);
    function EnvironmentService(http) {
        var _this = _super.call(this, http, MapperService.environmentMap) || this;
        _this._endpoint = '/odata/Environments';
        _this.environmentNameSuggest = function (searchTerm, fetchSize, skip) {
            if (searchTerm === void 0) { searchTerm = ''; }
            if (fetchSize === void 0) { fetchSize = 20; }
            if (skip === void 0) { skip = 0; }
            var queryOptions = {
                select: ['Id', 'Name'],
                orderBy: ['Name'],
                skip: skip,
                top: fetchSize,
                filter: {
                    'Name': {
                        contains: searchTerm,
                    },
                },
            };
            return _this
                .get(queryOptions)
                .pipe(map(function (res) { return ({
                total: res.total,
                data: res.data.map(function (environment) { return ({
                    id: environment.id,
                    text: environment.name,
                }); }),
            }); }));
        };
        return _this;
    }
    EnvironmentService.prototype.getRobotsIn = function (environmentId, queryOptions) {
        var _this = this;
        var environmentRobotsEndpoint = this._endpoint + "/UiPath.Server.Configuration.OData.GetRobotsForEnvironment(key=" + environmentId + ")";
        return this._http.get("" + environmentRobotsEndpoint + this.getQueryString(queryOptions))
            .pipe(map(function (res) { return _this._mapData(res, MapperService.robotMap); }));
    };
    EnvironmentService.prototype.getRobotIdsForEnvironment = function (environmentId) {
        return this._http.get(this._endpoint +
            ("/UiPath.Server.Configuration.OData.GetRobotIdsForEnvironment(key=" + environmentId + ")"))
            .pipe(map(function (data) { return data.value.map(function (id) { return ({ id: id }); }); }));
    };
    EnvironmentService.prototype.setRobots = function (environmentId, _a) {
        var add = _a.add, remove = _a.remove;
        var payload = {
            addedRobotIds: add.map(function (e) { return e.id; }),
            removedRobotIds: remove.map(function (e) { return e.id; }),
        };
        return this._http.post(this._endpoint + "(" + environmentId + ")/UiPath.Server.Configuration.OData.SetRobots", JSON.stringify(payload));
    };
    return EnvironmentService;
}(ODataService));
export { EnvironmentService };
